import { render, staticRenderFns } from "./InstitutionPublisherRow.vue?vue&type=template&id=5e2068c4"
import script from "./InstitutionPublisherRow.vue?vue&type=script&lang=js"
export * from "./InstitutionPublisherRow.vue?vue&type=script&lang=js"
import style0 from "./InstitutionPublisherRow.vue?vue&type=style&index=0&id=5e2068c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports